import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_3 = { class: "relative mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-300 mb-3.5" })
], -1)
const _hoisted_5 = { class: "relative flex justify-between" }
const _hoisted_6 = { class: "font-bold text-neutral-600 text-lg mb-3 bg-body pr-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "cursor-pointer button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit",
  type: "button"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 12.5L10 7.5L5 12.5",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "grid gap-8 mb-10 md-down:gap-4 grid-cols-3 md-down:grid-cols-1" }
const _hoisted_12 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg fill=\"none\" height=\"20\" viewBox=\"0 0 21 20\" width=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5240)\"><path clip-rule=\"evenodd\" d=\"M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z\" fill=\"#2AA797\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z\" fill=\"#2AA797\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_1704:5240\"><rect fill=\"white\" height=\"20\" transform=\"translate(0.667969)\" width=\"20\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Báo cáo hoàn thành </div></div>", 1)
const _hoisted_14 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_15 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_16 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg fill=\"none\" height=\"20\" viewBox=\"0 0 21 20\" width=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5253)\"><path clip-rule=\"evenodd\" d=\"M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_1704:5253\"><rect fill=\"white\" height=\"20\" transform=\"translate(0.332031)\" width=\"20\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Báo cáo chưa hoàn thành </div></div>", 1)
const _hoisted_18 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_19 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_20 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg fill=\"none\" height=\"20\" viewBox=\"0 0 21 20\" width=\"21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z\" fill=\"#2AA797\"></path><path clip-rule=\"evenodd\" d=\"M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z\" fill=\"#2AA797\" fill-rule=\"evenodd\"></path></svg><div class=\"text-neutral-500 text-sm ml-2\"> PH đã xem </div></div>", 1)
const _hoisted_22 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_23 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_24 = {
  key: 0,
  class: "shadow-sm sm:rounded-2xl overflow-hidden"
}
const _hoisted_25 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_26 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_27 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_28 = { class: "bg-neutral-100 h-16" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap",
  scope: "col"
}, " STT ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}, " Tên học sinh ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}, " Trạng Thái ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}, " Buổi học ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}, " Lĩnh vực ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}, " Mục tiêu ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
}, " Gửi tới PH ", -1)
const _hoisted_36 = {
  key: 0,
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col"
}, " PH ĐÃ XEM ", -1)
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "px-3 py-4 text-center text-neutral-700" }
const _hoisted_40 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_41 = { class: "flex items-center gap-4" }
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<svg fill=\"none\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_23962_63499)\"><path clip-rule=\"evenodd\" d=\"M7.34111 8.43756C7.34111 9.90549 6.15158 11.1203 4.65835 11.1203C3.16511 11.1203 1.97559 9.88018 1.97559 8.41225C1.97559 6.94433 3.16511 5.72949 4.65835 5.72949C6.12627 5.72949 7.34111 6.96964 7.34111 8.43756ZM6.60714 11.3987C7.46765 11.7278 8.1763 12.3605 8.60656 13.1957C7.8979 13.7525 7.3158 14.4864 7.01209 15.3723C6.86023 15.8025 6.73369 16.2834 6.63245 16.739H0.634203C0.279876 16.739 -0.0238327 16.4352 0.00147638 16.0556C0.0520945 15.2457 0.229258 14.4358 0.507658 13.6766C0.887294 12.6136 1.69718 11.8037 2.70955 11.3987C3.26635 11.7784 3.94969 11.9809 4.65834 11.9809C5.367 11.9809 6.05034 11.7784 6.60714 11.3987ZM23.5136 13.6766C23.134 12.6136 22.3241 11.8037 21.3117 11.3987C20.7296 11.7784 20.0716 11.9809 19.3376 11.9809C18.6037 11.9809 17.9456 11.7784 17.3888 11.3987C16.5283 11.7278 15.8197 12.3605 15.3894 13.1957C16.0981 13.7525 16.6802 14.4864 16.9839 15.3723C17.1357 15.8278 17.2623 16.2834 17.3635 16.739H23.3618C23.7414 16.739 24.0451 16.4352 23.9945 16.0556C23.9692 15.2457 23.792 14.4358 23.5136 13.6766ZM22.0204 8.43756C22.0204 9.90549 20.8309 11.1203 19.3377 11.1203C17.8697 11.1203 16.6549 9.88018 16.6549 8.41225C16.6549 6.94433 17.8444 5.72949 19.3377 5.72949C20.8309 5.72949 22.0204 6.96964 22.0204 8.43756ZM13.9468 13.3729C13.39 13.7525 12.7066 13.955 11.998 13.955C11.2893 13.955 10.606 13.7525 10.0492 13.3729C9.03682 13.7778 8.20162 14.5877 7.82199 15.6507C7.54359 16.41 7.39173 17.2198 7.31581 18.0297C7.2905 18.4094 7.59421 18.7131 7.97384 18.7131H16.0221C16.4018 18.7131 16.7055 18.4094 16.6802 18.0297C16.6295 17.2198 16.4524 16.41 16.174 15.6507C15.7943 14.5877 14.9591 13.7778 13.9468 13.3729ZM14.6808 10.4117C14.6808 11.8796 13.4913 13.0945 11.9981 13.0945C10.5048 13.0945 9.31531 11.9049 9.31531 10.4117C9.31531 8.94378 10.5301 7.72894 11.9981 7.72894C13.466 7.72894 14.6808 8.91847 14.6808 10.4117Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_23962_63499\"><rect fill=\"white\" height=\"24\" width=\"24\"></rect></clipPath></defs></svg>", 1)
const _hoisted_43 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_44 = { class: "ml-6" }
const _hoisted_45 = {
  key: 0,
  fill: "none",
  height: "20",
  viewBox: "0 0 21 20",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1706:5649)\"><path clip-rule=\"evenodd\" d=\"M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z\" fill=\"#2AA797\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z\" fill=\"#2AA797\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_1706:5649\"><rect fill=\"white\" height=\"20\" transform=\"translate(0.5)\" width=\"20\"></rect></clipPath></defs>", 2)
const _hoisted_48 = [
  _hoisted_46
]
const _hoisted_49 = {
  key: 1,
  fill: "none",
  height: "20",
  viewBox: "0 0 21 20",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1739:6086)\"><path clip-rule=\"evenodd\" d=\"M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path><path clip-rule=\"evenodd\" d=\"M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z\" fill=\"#94A3B8\" fill-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_1739:6086\"><rect fill=\"white\" height=\"20\" transform=\"translate(0.5)\" width=\"20\"></rect></clipPath></defs>", 2)
const _hoisted_52 = [
  _hoisted_50
]
const _hoisted_53 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_54 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_55 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_56 = { class: "px-3 py-4 whitespace-nowrap" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = {
  key: 0,
  class: "px-3 py-4 whitespace-nowrap text-neutral-700"
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "text-xs font-medium leading-none text-white" }
const _hoisted_64 = { class: "ml-4 font-semibold text-blue-600" }
const _hoisted_65 = {
  class: "px-3 py-4 capitalize whitespace-nowrap",
  style: {"width":"100px"}
}
const _hoisted_66 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "250",
  src: _imports_0,
  width: "250"
}, null, -1)
const _hoisted_68 = {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}
const _hoisted_69 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlideOverWeekFilter = _resolveComponent("SlideOverWeekFilter")!
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.sideOverShow ? 'side-over--active' : '')
    }, [
      (_ctx.sideOverShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sideOverShow = false))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_SlideOverWeekFilter, {
        onCancel: _ctx.cancelFilter,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sideOverShow = false)),
        onSubmit: _ctx.submitFilter
      }, null, 8, ["onCancel", "onSubmit"])
    ], 2),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.weeklyReports && _ctx.weeklyReports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyReports, (lesson) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: lesson.date,
                    class: "mb-10"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(`Tuần ${_ctx.$filters.toWeek(
									lesson.date,
									true
								)} (${_ctx.$filters.formatDate2(
									lesson.date
								)} - ${_ctx.$filters.endWeek(lesson.date)})`), 1),
                        _createElementVNode("div", {
                          class: "bg-body pl-3",
                          onClick: ($event: any) => (_ctx.showHide(lesson.date))
                        }, [
                          _createElementVNode("button", _hoisted_8, [
                            _createElementVNode("div", {
                              class: _normalizeClass([{
										'rotate-180': _ctx.isHides.includes(
											lesson.date
										),
									}, "mr-1 transform"])
                            }, _hoisted_10, 2),
                            _createElementVNode("span", null, _toDisplayString(_ctx.isHides.includes(lesson.date)
										? 'Mở rộng'
										: 'Thu gọn'), 1)
                          ])
                        ], 8, _hoisted_7)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(lesson.stats.completed || 0), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(lesson.stats.incomplete || 0), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(lesson.stats.parent_read || 0), 1)
                        ])
                      ])
                    ]),
                    (!_ctx.isHides.includes(lesson.date))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("table", _hoisted_27, [
                                _createElementVNode("thead", _hoisted_28, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_29,
                                    _hoisted_30,
                                    _hoisted_31,
                                    _hoisted_32,
                                    _hoisted_33,
                                    _hoisted_34,
                                    _hoisted_35,
                                    (_ctx.isAdmin)
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_36, " Nộp bởi "))
                                      : _createCommentVNode("", true),
                                    _hoisted_37
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lesson.data, (item, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: item.id,
                                      class: _normalizeClass([
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										, "text-neutral-700 cursor-pointer hover:bg-orange-50"]),
                                      onClick: ($event: any) => (
											_ctx.$router.push(
												item?.state === 'completed'
													? `/report/week/group-class/${item.group_class.id}/${item.id}`
													: `/report/week/group-class/${
															item.group_class.id
													  }/edit?week_start=${
															item.week_start
													  }&${
															item.id
																? `report_id=${item.id}`
																: ''
													  }`
											)
										)
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_39, _toDisplayString(index + 1), 1)
                                      ]),
                                      _createElementVNode("td", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                          _hoisted_42,
                                          _createElementVNode("span", null, _toDisplayString(item?.group_class?.name), 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                          (
														item?.state ===
														'completed'
													)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_45, _hoisted_48))
                                            : (_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_52))
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(item?.sessions_count || 0), 1),
                                      _createElementVNode("td", _hoisted_54, _toDisplayString(item?.skill_count || 0), 1),
                                      _createElementVNode("td", _hoisted_55, _toDisplayString(item?.goal_count || 0), 1),
                                      _createElementVNode("td", _hoisted_56, [
                                        (
													item.state ===
														'completed' &&
													item.sent_at === null
												)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "button-p text-center btn--ghost",
                                              type: "button",
                                              onClick: _withModifiers(($event: any) => (
													_ctx.sendGroupReport(item)
												), ["stop"])
                                            }, " Gửi báo cáo ", 8, _hoisted_57))
                                          : (
													item.state ===
														'completed' &&
													item.sent_at
												)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, " Đã gửi "))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_59, "-"))
                                      ]),
                                      (_ctx.isAdmin)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_60, [
                                            (item?.submitted_by_staff)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: "flex items-center cursor-pointer",
                                                  onClick: _withModifiers(($event: any) => (
													_ctx.$router.push(
														`/record/employee/${item?.submitted_by_staff?.id}`
													)
												), ["stop"])
                                                }, [
                                                  (
														item?.submitted_by_staff
															?.profile_photo
															?.w200
													)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: 
														item?.submitted_by_staff
															?.profile_photo
															?.w200
													,
                                                        alt: "",
                                                        class: "shadow-sm inline-block h-6 w-6 rounded-full"
                                                      }, null, 8, _hoisted_62))
                                                    : (_openBlock(), _createElementBlock("span", {
                                                        key: 1,
                                                        style: _normalizeStyle({
														background:
															item
																?.submitted_by_staff
																?.profile_photo
																?.default
																?.color,
													}),
                                                        class: "inline-flex items-center justify-center h-6 w-6 rounded-full"
                                                      }, [
                                                        _createElementVNode("span", _hoisted_63, _toDisplayString(item
																?.submitted_by_staff
																?.profile_photo
																?.default
																?.initial), 1)
                                                      ], 4)),
                                                  _createElementVNode("div", _hoisted_64, _toDisplayString(item?.submitted_by_staff
															?.name), 1)
                                                ], 8, _hoisted_61))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_65, _toDisplayString(item.numbers_of_parent_read ||
													0) + "/ " + _toDisplayString(item.group_class
														?.parents_count || 0), 1)
                                      ])
                                    ], 10, _hoisted_38))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.isInfinityLoading)
                  ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                      key: 0,
                      "is-loading": _ctx.isLoading,
                      loaded: _ctx.stopLoad,
                      onInfiniteLoad: _ctx.getWeeklyReports
                    }, null, 8, ["is-loading", "loaded", "onInfiniteLoad"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, " Báo cáo tuần được tạo tự động dựa vào các báo cáo buổi học cá nhân trong tuần. Bạn hãy bắt đầu báo cáo các buổi học can thiệp trên app " + _toDisplayString(_ctx.$filters.terminology('teacher')) + ", để có thể làm báo cáo tuần cho học sinh dựa vào những báo cáo đó nhé. ", 1)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createVNode(_component_Loading)
        ]))
  ], 64))
}